export default __webpack_public_path__ + "static/media/video-chat-icon.51d2e49b.svg";